var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTagIconWithCircle = function SvgTagIconWithCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.232 10.103l3.871-3.87A.703.703 0 0 1 10.645 6h2.58a.76.76 0 0 1 .775.774v2.58a.703.703 0 0 1-.232.543l-3.871 3.87a.787.787 0 0 1-.542.233.787.787 0 0 1-.542-.232l-2.58-2.58a.748.748 0 0 1 0-1.085zm6.013-1.832a.518.518 0 0 0 .516-.516.518.518 0 0 0-.516-.516.518.518 0 0 0-.516.516c0 .284.232.516.516.516z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTagIconWithCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag-icon-with-circle.00af17530da66c7bed15a60a941f197b.svg";